import styled, { css } from 'styled-components';
import { FormGroup, Text, Card } from '@oneaudi/unified-web-components';
import { SYS_BREAKPOINT_LG, SYS_COLOR_FOREGROUND_NEUTRAL_400_LIGHT, SYS_COLOR_FOREGROUND_SIGNAL_NEGATIVE_DARK, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_350, SYS_SPACE_RELATIVE_2_XL, SYS_SPACE_RELATIVE_3_XL, SYS_FONT_SIZES_RELATIVE_100, SYS_COLOR_FOREGROUND_NEUTRAL_200_LIGHT, SYS_COLOR_FOREGROUND_NEUTRAL_800_LIGHT, } from '@oneaudi/unified-web-common';
import { SYS_SPACE_RELATIVE_LG, SYS_BORDER_RADIUS_MD, SYS_COLOR_FOREGROUND_NEUTRAL_400_DARK, SYS_COLOR_SURFACE_NEUTRAL_500_DARK, SYS_COLOR_TEXT_DISPLAY_DEFAULT_DARK, SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK, SYS_SPACE_RELATIVE_2_XL as SYS_SPACE_RELATIVE_2_XL_ALPHA, } from '@oneaudi/unified-web-alpha-common';
import { dynamicStylingHelper } from '../../../../utils';
export const FormWrapper = styled.div `
  display: flex;
  align-items: flex-start;
  ${dynamicStylingHelper(`gap: ${SYS_SPACE_FIXED_100}`, `gap: ${SYS_SPACE_FIXED_300}`)};
  @media (max-width: 600px) {
    flex-direction: column;
    ${dynamicStylingHelper(`gap: 0px;`, ` gap: ${SYS_SPACE_RELATIVE_2_XL_ALPHA}`)};
  }
`;
export const RadioWrapperToOverwriteLegacyCSS = styled.div `
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 20px;
`;
export const FormElementWrapper = styled.div `
  margin-block-end: ${SYS_SPACE_FIXED_300};
  display: flex;
  gap: ${SYS_SPACE_FIXED_100};
  align-items: center;
`;
export const ReadOnlyFormElementWrapper = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: ${dynamicStylingHelper(`20px`, `36px`)};
  justify-content: center;

  @media (max-width: 600px) {
    min-height: auto;
  }
`;
export const ReadOnlyGroup = styled.div `
  margin-bottom: ${SYS_SPACE_FIXED_350};
  margin-left: ${SYS_SPACE_FIXED_300};
  margin-right: ${SYS_SPACE_FIXED_300};
  margin-top: ${SYS_SPACE_FIXED_350};
  display: flex;
  gap: ${SYS_SPACE_FIXED_150};
  flex-direction: column;
`;
export const RateWrapper = styled.div `
  display: flex;
  input {
    font-size: x-large;
    font-weight: bold;
    padding: 0px;
  }
  div #Rate__hint-message {
    flex-direction: row-reverse;
    margin: 0px;
  }
`;
export const WebCalcErrWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
export const WebCalcErrContainer = styled.div `
  display: flex;
  flex-direction: row;
  margin: 0px ${SYS_SPACE_FIXED_300} ${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_300};
  color: ${SYS_COLOR_FOREGROUND_SIGNAL_NEGATIVE_DARK};

  p {
    color: ${SYS_COLOR_FOREGROUND_SIGNAL_NEGATIVE_DARK};
    margin: 0px;
  }

  .web-calc-error-headline {
    ${dynamicStylingHelper(`color: var(--Global-Color-Typography-Headline-Default, #333);`, `color: ${SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK};`)};
  }
`;
export const FormColumnWrapper = styled.div `
  flex: 1;
  ${dynamicStylingHelper(`margin-bottom: ${SYS_SPACE_FIXED_300};`)};
  width: 100%;
`;
export const ReadOnlyColumn = styled.div `
  flex: 1;
  ${dynamicStylingHelper(`background-color: #fff;
    margin-bottom: ${SYS_SPACE_FIXED_300};`, `
    background-color: ${SYS_COLOR_SURFACE_NEUTRAL_500_DARK};
    border-radius: ${SYS_BORDER_RADIUS_MD};
    `)};
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0 2px 6px rgba(0, 0, 0, 0.2));
  height: 100%;
  width: 100%;
`;
export const ProductWrapper = styled.div `
  display: block;
  flex-wrap: wrap;

  legend {
    ${dynamicStylingHelper(``, `color: ${SYS_COLOR_TEXT_DISPLAY_DEFAULT_DARK};`)};
  }
`;
export const popupContentStyles = css `
  width: 600px;
  max-width: none;
`;
export const HeadingWrapper = styled.div `
  h2 {
    hyphens: auto;
    word-break: break-word;
  }
`;
export const RadioWrapper = styled(FormGroup) `
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: row;

  > legend {
    font-size: ${SYS_FONT_SIZES_RELATIVE_100};
    font-weight: 700;
    ${dynamicStylingHelper(`margin: 0 0 ${SYS_SPACE_FIXED_300} 0;`, `margin: 0 0 ${SYS_SPACE_RELATIVE_LG} 0;`)};
    ${dynamicStylingHelper(`color: ${SYS_COLOR_FOREGROUND_NEUTRAL_200_LIGHT};`)};
  }
  > legend + div {
    flex-direction: row;
  }
`;
export const InputWrapper = styled.div `
  width: 90%;
`;
export const CTAWrapper = styled.div `
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
  align-items: flex-start;
  flex-wrap: wrap;
  gap: ${SYS_SPACE_FIXED_100};
  align-self: stretch;
`;
export const WrapperToOverwriteLegacyCSS = styled.div `
  > .downPayment > div {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row-reverse;
    align-items: flex-end;
    justify-content: space-between;

    > div:first-child {
      display: flex;
      flex-grow: 1;
    }
    > div:last-child {
      text-align: start;
      padding-left: 0px;
      padding-right: 0px;
      min-width: 15px;
    }
  }
  input {
    @media screen and (max-width: 479px) {
      height: auto !important;
    }
  }
`;
export const ReadonlyInputWrapper = styled.div `
  width: 100%;
  min-height: 20px;
  span {
    hyphens: auto;
    word-break: break-word;
  }
  input {
    display: none;
  }
  .read-only-value {
    ${({ IsLoading }) => IsLoading
    ? dynamicStylingHelper(`color: ${SYS_COLOR_FOREGROUND_NEUTRAL_400_LIGHT}`, `color: ${SYS_COLOR_FOREGROUND_NEUTRAL_400_DARK}`)
    : ''};
  }
`;
export const InfoIcontainer = styled.div `
  display: block;
  width: 16px;
  align-self: center;
  margin-left: ${SYS_SPACE_FIXED_100};

  div {
    margin: 0px;
  }
`;
export const FlexWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: nowrap;
  gap: ${SYS_SPACE_FIXED_100};

  span {
    display: flex;
    align-items: center;
    button {
      margin-bottom: 10px;
    }
  }

  @media (max-width: 600px) {
    justify-content: space-between;
    gap: ${SYS_SPACE_FIXED_150};
  }
`;
export const RateFlexWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-block-end: 0px;
  gap: ${SYS_SPACE_FIXED_100};

  span {
    display: flex;
    align-items: center;

    button {
      margin-bottom: 10px;
    }
  }
`;
export const ReadOnlyValue = styled.div `
  display: inline-flex;
  align-items: flex-start;
  flex: 0 1 auto;
  min-width: 0;

  p {
    margin: 0;
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: normal;
    hyphens: auto;
  }
`;
export const BreakdownValueWrapper = styled.div `
  display: flex;
  align-items: flex-start;
  flex: ${({ align }) => (align === 'right' ? '0 1 auto' : '1 1 auto')};
  min-width: 0;
  justify-content: ${({ align }) => (align === 'right' ? 'flex-end' : 'flex-start')};

  p {
    line-height: 1.4;
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: normal;
    hyphens: auto;
    margin: 0;
    text-align: ${({ align }) => (align === 'right' ? 'right' : 'left')};
  }

  @media (max-width: 600px) {
    width: auto;
  }
`;
export const FinanceModalWrapper = styled.div `
  display: flex;
  flex-direction: column;
  ${dynamicStylingHelper(`gap: ${SYS_SPACE_RELATIVE_2_XL}`, `gap: ${SYS_SPACE_RELATIVE_2_XL_ALPHA};`)};

  margin-bottom: ${SYS_SPACE_RELATIVE_3_XL};
  .default-color-text {
    ${dynamicStylingHelper(``, `color: ${SYS_COLOR_TEXT_DISPLAY_DEFAULT_DARK};`)};
  }
`;
export const FinanceCashModalWrapper = styled.div `
  display: flex;
  width: 100%;
  flex-direction: column;
  ${dynamicStylingHelper(`gap: ${SYS_SPACE_RELATIVE_2_XL}`, `gap: ${SYS_SPACE_RELATIVE_2_XL_ALPHA};`)};

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    flex-direction: row;
    gap: ${SYS_SPACE_FIXED_300};
  }
`;
export const FinanceModalitiesContainer = styled.div `
  display: flex;
  flex-direction: column;
  ${dynamicStylingHelper(`gap: ${SYS_SPACE_RELATIVE_2_XL}`, `gap: ${SYS_SPACE_RELATIVE_2_XL_ALPHA};`)};
`;
export const CashBreakdownValueWrapper = styled.div `
  display: inline-flex;
  align-items: center;
`;
export const FinanceCashSummaryWrapper = styled.div `
  width: 100%;
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    width: 50%;
  }
`;
export const FinanceCashCardWrapper = styled(Card) `
  background-color: ${SYS_COLOR_SURFACE_NEUTRAL_500_DARK};
  ${dynamicStylingHelper(`background-color: ${SYS_COLOR_FOREGROUND_NEUTRAL_800_LIGHT};`, `background-color: ${SYS_COLOR_SURFACE_NEUTRAL_500_DARK};`)};
`;
export const PriceValue = styled(Text) `
  ${dynamicStylingHelper('', `color: ${SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK};`)};
  display: inline-flex;
`;
